import { useQuery } from "react-query";
import { getRequsites } from "../requests/getRequsites";

export default function useGetRequsites(dealerId: string, switcher: boolean) {
  return useQuery({
    queryKey: ["getRequsites", { dealerId }],
    queryFn: () => getRequsites(dealerId),
    refetchOnWindowFocus: false,
    enabled: switcher,
  });
}
